import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import Categoria from '../components/Categoria.vue'
import Login from '../components/Login.vue'
import Usuario from '../components/Usuario.vue'
import Articulo from '../components/Articulo.vue'
import Cliente from '../components/Cliente.vue'
import Proveedor from '../components/Proveedor.vue'
import Ingreso from '../components/Ingreso.vue'
import Venta from '../components/Venta.vue'
import Cobros from '../components/Cobros.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      administrador: true,
      almacenero: true,
      vendedor: true
    },
    },
    {
        path: '/categoria',
        name: 'categoria',
        component: Categoria,
        meta: {
            administrador: true,
            almacenero: true,
      },
    },
    {
        path: '/articulo',
        name: 'articulo',
        component: Articulo,
        meta: {
            administrador: true,
            almacenero: true,
      },
    },
    {
        path: '/ingreso',
        name: 'ingreso',
        component: Ingreso,
        meta: {
            administrador: true,
            almacenero: true,
      },
    },
    {
        path: '/cliente',
        name: 'cliente',
        component: Cliente,
        meta: {
            administrador: true,
            vendedor: true,
      },
    },
    {
        path: '/venta',
        name: 'venta',
        component: Venta,
        meta: {
            administrador: true,
            vendedor: true,
      },
    },
    {
    path: '/cobros',
    name: 'cobros',
    component: Cobros,
    meta: {
      administrador: true,
      vendedor: true,
    },
  },
  {
        path: '/proveedor',
        name: 'proveedor',
        component: Proveedor,
        meta: {
            administrador: true,
            almacenero: true,
      },
    },
    {
        path: '/usuario',
        name: 'usuario',
        component: Usuario,
        meta: {
            administrador: true,
      },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            libre: true,
      },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.libre)) {
        next();
    } else if (store.state.usuario && store.state.usuario.rol == 'Administrador') {
      next();
    } else if (store.state.usuario && store.state.usuario.rol == 'Almacenero') {
      next();
    } else if (store.state.usuario && store.state.usuario.rol == 'Vendedor') {
      next();
    } else {
        next({ name: 'login' });
    }
})

export default router;